/**
 * Created by mukund on 8/24/17.
 */

angular.module('mediacloudApp')
    .directive('profileSelector', ['ProfileService', 'BatchService', 'UploadErrors', function(ProfileService, BatchService, UploadErrors){
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'scripts/components/upload/directives/profiles/profiles.html',
            scope: {
                batch: '=',
                tracker: '=',
                errors: '=',
                upload: '&',
                tenant: '=',
                cancelUpload: '&'
            },
            link: function(scope, element, attrs){

                scope.audioSampleRateBtn = {
                    isOpen: false
                };
                scope.audioChannelsBtn = {
                    isOpen: false
                };

                scope.audioSampleRates = [8000, 11025, 16000, 22050, 32000, 44100, 48000, 50000, 96000];
                scope.audioChannels = [1, 2, 3];

                scope.numVideoProfilesSelected = 0;
                scope.numAudioProfilesSelected = 0;

                // Make the custom profile selection modals accessible
                $("#profileSettings").on('shown.bs.modal', function () {
                    modalFocus('#profileSettingsHeading', '#chooseProfilesBtn');
                });
                $("#fileList").on('shown.bs.modal', function () {
                    modalFocus('#chooseProfilesHeading', '#confirmProfileSelectionBtn');
                });
                $("#profileSelect").on('shown.bs.modal', function () {
                    modalFocus('#returnToFileListBtn', '#returnToBackBtn');
                    $('#returnToBackBtn').on('focus', function(){
                        $('#returnToFileListBtn').focus()
                    });
                });
                $("#createProfile").on('shown.bs.modal', function () {
                    modalFocus('#backToExistingProfilesBtn', '#returnToExistingProfilesBtn');
                    $('#returnToExistingProfilesBtn').on('focus', function(){
                        $('#backToExistingProfilesBtn').focus()
                    });
                });

                var modalFocus = function(first, last){
                    var firstItem = $(first),
                        lastItem = $(last);

                    /*set focus on first item*/
                    firstItem.focus();

                    /*redirect last tab to first input*/
                    lastItem.on('keydown', function (e) {
                        if ((e.which === 9 && !e.shiftKey)) {
                            e.preventDefault();
                            firstItem.focus();
                        }
                    });

                    /*redirect first shift+tab to last input*/
                    firstItem.on('keydown', function (e) {
                        if ((e.which === 9 && e.shiftKey)) {
                            e.preventDefault();
                            lastItem.focus();
                        }
                    });
                };

                scope.setSelectedFile = function(fileObj){
                    scope.selectedFile = fileObj;
                };

                scope.getProfiles = function(){
                    scope.clearProfileSelection();
                    ProfileService.query(function(profiles){
                        scope.profiles = profiles;
                        var selectedProfiles = scope.selectedFile === 'all' ? scope.batch.profiles : scope.selectedFile.profiles;
                        angular.forEach(scope.profiles, function(profile){
                            if(selectedProfiles.indexOf(profile.id) > -1) {
                                profile.selected = true;
                                if(profile.type === 'Audio'){
                                    scope.numAudioProfilesSelected++;
                                }else if(profile.type === 'VIDEO'){
                                    scope.numVideoProfilesSelected++;
                                }
                            }
                        });
                    }, function(){
                        scope.errors.push({id: 'pe' + Date.now(), msg: UploadErrors.GET_PROFILES});
                    });
                };

                scope.selectProfile = function(profile){
                    if(profile.type === 'AUDIO') {
                        if (scope.numVideoProfilesSelected === 0) {
                            scope.numAudioProfilesSelected = profile.selected ? scope.numAudioProfilesSelected - 1 : scope.numAudioProfilesSelected + 1;
                            profile.selected = !profile.selected;
                        }
                    } else if(profile.type === 'VIDEO'){
                        if (scope.numAudioProfilesSelected === 0) {
                            scope.numVideoProfilesSelected = profile.selected ? scope.numVideoProfilesSelected - 1 : scope.numVideoProfilesSelected + 1;
                            profile.selected = !profile.selected;
                        }
                    }
                };

                scope.clearProfileSelection = function(){
                    scope.numVideoProfilesSelected = 0;
                    scope.numAudioProfilesSelected = 0;
                };

                scope.clearAssociatedProfiles = function(event){
                    applyProfiles([]);
                    scope.clearProfileSelection();
                    event.stopPropagation()
                };

                scope.confirmProfileSelection = function(){
                    var selectedProfiles = [];
                    angular.forEach(scope.profiles, function (profile) {
                        if (profile.selected) {
                            selectedProfiles.push(profile.id);
                        }
                    });
                    applyProfiles(selectedProfiles);
                    scope.clearProfileSelection();
                };

                var applyProfiles = function(profiles){
                    if(scope.selectedFile === 'all'){
                        scope.batch.profiles = profiles;
                        // Apply selectedProfiles to all files in the batch
                        angular.forEach(scope.batch.files, function(file){
                            file.profiles = profiles;
                        });
                    }else{
                        scope.selectedFile.profiles = profiles;
                    }
                };

                scope.newProfile = {
                    name: "Custom_Profile",
                    type: "AUDIO",
                    audioSampleRate: 48000,
                    audioChannels: 2,
                    audioBitrate: 128,
                    videoBitrate: 720
                };

                scope.setProfileAudioSampleRate = function(value){
                    scope.newProfile.audioSampleRate = value;
                    scope.audioSampleRateBtn.isOpen = false;
                };

                scope.setProfileAudioChannels = function(value){
                    scope.newProfile.audioChannels = value;
                    scope.audioChannelsBtn.isOpen = false;
                };

                scope.createProfile = function(){
                    var profileResource = new ProfileService({
                        name: scope.newProfile.name ? scope.newProfile.name : "Custom_Profile",
                        type: scope.newProfile.type,
                        audioBitrate: scope.newProfile.audioBitrate * 1000,
                        videoBitrate: scope.newProfile.videoBitrate * 1000,
                        audioChannels: scope.newProfile.audioChannels,
                        audioSampleRate: scope.newProfile.audioSampleRate
                    });
                    profileResource.$save(function(){
                        // Reload profiles for the selected file once the new profile is created
                        scope.getProfiles();
                    }, function(){
                        scope.errors.push({id: 'pe' + Date.now(), msg: UploadErrors.CREATE_PROFILE});
                    });
                };

                /**
                 * Show Watson modal, if configured for the client. If not, start the upload
                 */
                scope.showCaptioningOptions = function(){
                    if(scope.tenant.captioningServiceList.length && scope.tenant.captioningServiceList.indexOf('WATSON') > -1){
                        $('#watsonmodal').modal('show');
                    } else {
                        scope.upload();
                    }
                };
            }
        }
    }]);
